import type { CpeRapport } from "@/types/cpe";
import type { CperapportState } from "@/types/store";
import type { MutationTree } from "vuex";

// Mutations
export const LOAD_CPERAPPORTS = "LOAD_CPERAPPORTS";
export const LOAD_CPERAPPORTS_SUCCESS = "LOAD_CPERAPPORTS_SUCCESS";
export const LOAD_CPERAPPORTS_FAILURE = "LOAD_CPERAPPORTS_FAILURE";

export const LOAD_CPERAPPORT = "LOAD_CPERAPPORT";
export const LOAD_CPERAPPORT_SUCCESS = "LOAD_CPERAPPORT_SUCCESS";
export const LOAD_CPERAPPORT_FAILURE = "LOAD_CPERAPPORT_FAILURE";

export const ADD_CPERAPPORT = "ADD_CPERAPPORT";
export const ADD_CPERAPPORT_SUCCESS = "ADD_CPERAPPORT_SUCCESS";
export const ADD_CPERAPPORT_FAILURE = "ADD_CPERAPPORT_FAILURE";

export const UPDATE_CPERAPPORT = "UPDATE_CPERAPPORT";
export const UPDATE_CPERAPPORT_SUCCESS = "UPDATE_CPERAPPORT_SUCCESS";
export const UPDATE_CPERAPPORT_FAILURE = "UPDATE_CPERAPPORT_FAILURE";

export const DELETE_CPERAPPORT = "DELETE_CPERAPPORT";
export const DELETE_CPERAPPORT_SUCCESS = "DELETE_CPERAPPORT_SUCCESS";
export const DELETE_CPERAPPORT_FAILURE = "DELETE_CPERAPPORT_FAILURE";

export const mutations: MutationTree<CperapportState> = {
  [LOAD_CPERAPPORTS](state: CperapportState) {
    state.cperapports = {
      ...state.cperapports,
      loading: true,
      error: null,
    };
  },
  [LOAD_CPERAPPORTS_SUCCESS](state: CperapportState, data: any) {
    state.cperapports = {
      data: data.data,
      loading: false,
      error: null,
      count: data.total_count,
    };
  },
  [LOAD_CPERAPPORTS_FAILURE](state: CperapportState, error: string) {
    state.cperapports = { ...state.cperapports, loading: false, error };
  },
  [ADD_CPERAPPORT](state: CperapportState) {
    state.cperapports = {
      ...state.cperapports,
      loading: true,
      error: null,
    };
  },
  [ADD_CPERAPPORT_SUCCESS](state: CperapportState, bexrapport: CpeRapport) {
    state.cperapports = {
      ...state.cperapports,
      data: [...state.cperapports.data, bexrapport],
      loading: false,
      error: null,
    };
  },
  [ADD_CPERAPPORT_FAILURE](state: CperapportState, error: string) {
    state.cperapports = { ...state.cperapports, loading: false, error };
  },
  [UPDATE_CPERAPPORT](state: CperapportState) {
    state.cperapports = {
      ...state.cperapports,
      loading: true,
      error: null,
    };
  },
  [UPDATE_CPERAPPORT_SUCCESS](state: CperapportState, bexrapport: any) {
    state.cperapports.loading = false;
    state.cperapports.error = null;
    const index = state.cperapports.data.findIndex(
      (item: any) => item.id === bexrapport.id,
    );
    if (index !== -1) state.cperapports.data[index] = bexrapport;
  },
  [UPDATE_CPERAPPORT_FAILURE](state: CperapportState, error: string) {
    state.cperapports = { ...state.cperapports, loading: false, error };
  },

  [LOAD_CPERAPPORT](state: CperapportState) {
    state.cperapport = { ...state.cperapport, loading: true, error: null };
  },
  [LOAD_CPERAPPORT_SUCCESS](state: CperapportState, event: CpeRapport) {
    state.cperapport = {
      data: event,
      loading: false,
      error: null,
    };
  },
  [LOAD_CPERAPPORT_FAILURE](state: CperapportState, error: string) {
    state.cperapport = {
      ...state.cperapport,
      loading: false,
      error: error,
    };
  },

  [DELETE_CPERAPPORT](state: CperapportState) {
    state.cperapports = { ...state.cperapports, loading: true, error: null };
  },
  [DELETE_CPERAPPORT_SUCCESS](state: CperapportState, id: any) {
    state.cperapports = {
      data: state.cperapports.data.filter(
        (sc: CpeRapport) => sc.reportId !== id,
      ),
      loading: false,
      error: null,
      count: state.cperapports.count - 1,
    };
  },
  [DELETE_CPERAPPORT_FAILURE](state: CperapportState, error: string) {
    state.cperapports = {
      ...state.cperapports,
      loading: false,
      error: error,
    };
  },
};
